module.exports = __webpack_public_path__ + "static/MOMO3-8a4855390634c149b4a4abd9cc3d1b66.jpg";